import { render, staticRenderFns } from "./NewRirekishoAiMyprCard.vue?vue&type=template&id=21aa4925&scoped=true"
import script from "./NewRirekishoAiMyprCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoAiMyprCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoAiMyprCard.vue?vue&type=style&index=0&id=21aa4925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa4925",
  null
  
)

export default component.exports